const SpinerSubmit = () => {
    return (<i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>)
}

export default SpinerSubmit